"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".premiumAdTokenPayment .mat-form-field-subscript-wrapper{position:relative}.mat-progress-spinner circle,.mat-spinner circle{stroke:#fff!important}"];
exports.styles = styles;
